const SLICE_SIZE = 512;

const b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Uint8Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(byteNumbers);
    }
    return new Blob(byteArrays, { type: contentType });
};

const downloadBase64Data = (data, contentType, fileName) => {
    const blob = b64toBlob(data, contentType, SLICE_SIZE);
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(downloadLink);
    }
};

export {
    downloadBase64Data,
};
